<div class="all-options-header">
  <div (click)="onClickHide($event)" class="hide-all">
    <h6 uni-heading weight="normal" [color]="isUnitPortalStyle ? 'info-unit' : 'info'">Ocultar todas las opciones</h6>
  </div>
  <uni-form-field>
    <uni-icon uniPrefix color="muted" name="search"></uni-icon>
    <input placeholder="Buscar" [formControl]="searchControl" uniInput />
  </uni-form-field>
</div>

<div class="row">
  <div class="col-12">
    <div class="mg-l-10 mg-b-10 bg-white">
      <uni-list [wrap]="true" gap="none" orientation="horizontal" bullet="none">
        <ngx-masonry [options]="masonryOptions">
          <div class="grid-sizer"></div>
          <uni-list-item ngxMasonryItem class="menu-section-option" *ngFor="let section of filteredSections">
            <div class="mg-b-6 mg-t-6">
              <a uni-link animation="fade" [routerLink]="section.url">
                <h5 uni-heading [color]="section.selected ? (isUnitPortalStyle ? 'primary-unit' : 'primary') : 'muted'">
                  {{ section.name }}
                </h5>
              </a>
            </div>
            <uni-list gap="lg" [bullet]="isUnitPortalStyle ? 'info-unit' : 'info'">
              <uni-list-item [bullet]="!sectionChild.selected && 'muted'" *ngFor="let sectionChild of section.childs">
                <a
                  uni-link
                  animation="fade"
                  [routerLink]="sectionChild.url"
                  [variant]="sectionChild.selected ? (isUnitPortalStyle ? 'primary-unit' : 'primary') : 'muted'"
                >
                  {{ sectionChild.name }}
                </a>
              </uni-list-item>
            </uni-list>
          </uni-list-item>
        </ngx-masonry>
      </uni-list>
    </div>
  </div>
</div>
